import { memo } from 'react';
import { Tooltip } from 'antd';
import { useGetParentSummaryQuery } from '@/services/parent-api';
import { EditSvg, NewspaperSvg } from '@/assets/icons';
import Panel from '@/components/panel';
import Button from '@/components/button';
import { ProfileCol, ProfileRow } from '@/components/profile-grid';

const LeadSource = ({ parentId, permissions }) => {
  const { data, isLoading } = useGetParentSummaryQuery({ parentId });

  return (
    <Panel
      icon={<NewspaperSvg />}
      title="Lead Source"
      extra={
        permissions.adminStaffAndSuper && (
          <Tooltip title="Edit Lead Source">
            <Button type="link" icon={<EditSvg fontSize="16" />} to="../edit" />
          </Tooltip>
        )
      }
      loading={isLoading}
    >
      {data && (
        <ProfileRow>
          <ProfileCol md={12} lg={8} label="Lead Source" value={data.lead.source.name} />
          <ProfileCol md={12} lg={8} label="Source Detail" value={data.lead.sourceType.name || 'None'} />
          <ProfileCol md={12} lg={8} label="Initial Contact Type" value={data.lead.initialContactType.name || 'None'} />
          <ProfileCol md={12} lg={8} label="Reason" value={data.lead.inquiryReason.name} />
        </ProfileRow>
      )}
    </Panel>
  );
};

export default memo(LeadSource);
